import { useMemo } from 'react';
import { useTrainersGroupFilter } from '~/Hooks/useFilter/useTrainersGroupFilter';
import { useLocationsGroupFilter } from '~/Hooks/useFilter/useLocationsGroupFilter';
import { useEventCategoriesGroupFilter } from '~/Hooks/useFilter/useEventCategoriesGroupFilter';
import { AccessList, useHasAccess } from '~/Hooks';
import { useGroupFilter, FilterType } from '~/Hooks/useFilter';
import { SegmentName } from '~/Constants/Segment.constants';
import { Segment } from '~/Helpers/Segment.helper';
import { useEventStatusFilter } from '~/Hooks/useFilter/useEventStatusFilter';
import { useEventSportsCategoriesGroupFilter } from '~/Hooks/useFilter/useEventSportsCategoriesGroupFilter';

export const useEventGroupFilter = () => {
  const { hasAccess } = useHasAccess();
  const filterType = FilterType.EVENT_GROUP_FILTER;
  const trainersGroup = useTrainersGroupFilter({ filterType });
  const locationsGroup = useLocationsGroupFilter({ filterType });
  const categoriesGroup = useEventCategoriesGroupFilter({ filterType });
  const sportsCategoriesGroup = useEventSportsCategoriesGroupFilter({ filterType });
  const statusGroup = useEventStatusFilter({ filterType });

  const groups = useMemo(
    () => [
      ...(hasAccess(AccessList.EVENT_GROUP_FILTER_CATEGORIES) ? [categoriesGroup] : []),
      sportsCategoriesGroup,
      ...(hasAccess(AccessList.TRAINER_FILTER) ? [trainersGroup] : []),
      locationsGroup,
      statusGroup,
    ],
    [hasAccess, trainersGroup, locationsGroup, categoriesGroup, statusGroup],
  );

  const trackingEvents = {
    onClear: () => Segment.track(SegmentName.EVENT_GROUPS_FILTER_CLEAR),
    onApply: (params?: Record<string, boolean | string | any[]>) =>
      Segment.track(SegmentName.EVENT_GROUPS_FILTER_APPLY, params),
    onOpen: () => Segment.track(SegmentName.EVENT_GROUPS_FILTER_OPEN),
  };

  return useGroupFilter({
    groups,
    trackingEvents,
    filterType,
  });
};
